import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Router} from '@angular/router';
import {Guid} from 'guid-typescript';
import {
    AddFxRateReportDynamicFieldsCommand,
    CreateReportCommand,
    DeleteReportCommand
} from '../../commands/fx-rate-report.command';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Configuration} from '@shared/models/configuration';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { FuseSidebarService } from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {select, Store} from '@ngrx/store';
import {getApplicationWithId, ParticleState} from '@shared/store/reducers/particle.reduer';
import {
  SetActivityFeedAction,
  SetCurrentRightSideBarFoldOrNotAction,
  SetCurrentRightSideComponentAction
} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {PlatformSidebarService} from "@shared/components/platform-sidebar/store/platform-sidebar.service";
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {getFeaturesInfo, hasFeature} from '@shared/store/selectors/security.selector';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-fx-rate-report-content',
    templateUrl: './fx-rate-report-content.component.html',
    styleUrls: ['./fx-rate-report-content.component.scss']
})
export class FxRateReportContentComponent implements OnInit, OnDestroy {
    appUrl = '';
    breadcrumbs: BreadcrumbModel[];
    invalidateSubject = new InvalidateSubject();
    sourceType = 'FxRate-Reports';
    detailsSourceType = 'FxRateReportDetails';
    sortFieldKey: string;
    sortDirection: string;
    recordCount: number = 0;

    ngUnsubscribe = new Subject<void>();
    hasKPMGFeature: boolean;
    kpmgSourceType = 'KPMG-FxRate-Reports';
    isDataLoaded: boolean;

    constructor(private store: Store<ParticleState>,
                private router: Router,
                private commandService: CommandService,
                private snackBarService: SnackBarService,
                private dialogService: DialogService,
                private fuseSplashScreenService: FuseSplashScreenService,
                private platformSidebarStore: Store<PlatformSidebarState>,
                private platformSidebarService: PlatformSidebarService,
                private sidebarService: FuseSidebarService,
                private securityStore: Store<SecurityState>) {
        this.breadcrumbs = [
            <BreadcrumbModel>{
                id: 'fx-rates',
                title: 'FX Rates',
                type: '',
                relativeUrl: 'itrce/fxrates'
            }
        ];
        this.sortFieldKey = 'CreateDate';
        this.sortDirection = 'dsc';
        this.recordCount = 0;
    }

    ngOnInit() {
      this.isDataLoaded = false;
      this.store.pipe(select(getApplicationWithId, 'ITCE')).subscribe(app => {
        if (app && app.HostUrl) {
          this.appUrl = app.HostUrl;
        }
      });

      this.hasKPMGFeature = false;
      this.securityStore.pipe(select(getFeaturesInfo), takeUntil(this.ngUnsubscribe)).subscribe(features => {
        if (Object.keys(features).length !== 0) {
          this.hasKPMGFeature = features['KPMG'];
          this.isDataLoaded = true;
          if (this.hasKPMGFeature) {
            this.sourceType = this.kpmgSourceType;
          }
        }
      });
      // this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', 'id': `${this.chapterDocument.id}-${this.activeItem.categoryId}`, 'title': activityFeedTitle, isDefault: false}));
      //
      // this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction({
      //   component: 'ActivityFeedComponent',
      //   data: {
      //     //analyticsPage : 'LawChangesSideBar'
      //     isUserAction: false
      //   },
      //   componentInfo: {}
      // }));

    }

    addReport() {
        const reportID = Guid.create().toString();
        this.router.navigateByUrl(`itrce/fxrates/add-report/${reportID}`);
    }

    createReport() {
        const dialogModel = DialogModel.create('Create Report', 'CreateFxRateDialogComponent', {});
        this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
            if (res.action === 'OK') {
                if (res.data.input) {
                    const command = new CreateReportCommand();
                    command.reportName = res.data.input['reportName'];
                    command.rateType = res.data.input['rateType'];
                    this.fuseSplashScreenService.show();
                    this.commandService.executeCommand(command).subscribe(data => {
                        this.fuseSplashScreenService.hide();
                        if (data) {
                            const reportId = data.Payload.Id;
                            this.router.navigateByUrl(`itrce/fxrates/add-report/${reportId}`);
                        }
                    }, () => {
                        this.fuseSplashScreenService.hide();
                    });
                }
            }
        });


    }

    applyFilter() {

    }

    onRecordCountChange(recordCount) {
        this.recordCount = recordCount;
        console.log(`Record Count: ${recordCount}` );
    }

    onGridCellValueChange(event) {
        if (event.fieldDefinition && event.fieldDefinition.key === 'ReportName') {
            const item = event.item;
            const reportName = item.cells['ReportName'].value;

            const reportingCurrencies = item.cells['ReportingCurrencies'];
            const translationCurrencies = item.cells['TranslationCurrencies'];

            if (reportingCurrencies && reportingCurrencies.value && translationCurrencies && translationCurrencies.value) {
                this.addDynamicFieldsCommad(event.item.id, reportName);
            } else {
                this.dialogService.showDialogMessage('Message', 'Please edit the report and select reporting currencies and translation currencies first.');
            }

            // this.router.navigateByUrl(`itrce/fxrates/fx-rates-view-report/${reportName}/${event.item.id}`);
            return;
        }
        if (event.action) {
            switch (event.action.id) {
                case 'Edit':
                    this.router.navigateByUrl(`itrce/fxrates/add-report/${event.item.id}`);
                    break;
                case 'Delete':
                    this.deleteReport(event.item.id);
                    break;
              case 'ShowActivities':
                this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', 'id': `${event.item.id}`, 'title': event.item.cells['ReportName'].value, isDefault: false, isUserAction: true}));
                break;
            }
        }
    }

    addDynamicFieldsCommad(reportId: string, reportName: string) {
        const command = new AddFxRateReportDynamicFieldsCommand();
        command.reportId = reportId;
        command.sourceType = this.detailsSourceType;
        command.rateView = 'SimpleAverage';
        this.commandService.executeCommand(command).pipe().subscribe(state => {
            if (state) {
                console.log(state);
                this.invalidateSubject.invalidate();
                const config = Configuration.getSmartGridConfig(this.sourceType);
                config.SourceType = state.Payload.SourceType;
                config.Parameters['REPORT_ID'] = reportId;
                Configuration.setSmartGridConfig(config.SourceType, config);
                // Segment-array navigation: the URL serializer escapes "(" and ")" (which encodeURIComponent leaves alone and the router would otherwise read as an auxiliary-outlet group).
                this.router.navigate(['itrce', 'fxrates', 'fx-rates-view-report', reportName, reportId]);
            }
        });
    }


    deleteReport(reportId: string) { // on html empty string passed for build fix.
        const command = new DeleteReportCommand();
        command.reportId = reportId;
        this.commandService.executeCommand(command).pipe().subscribe(state => {
            if (state) {
                this.invalidateSubject.invalidate();
                this.snackBarService.showInformation('Deleted Successfully');
            }
        });

    }

  ngOnDestroy(): void {
    if (this.sidebarService.getSidebar('rightsidebar')) {
      this.sidebarService.getSidebar('rightsidebar').close();
      this.sidebarService.getSidebar('rightsidebar').fold();
    }
    this.platformSidebarService.hideSidebarIcon("Related Law Changes");
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
